import DOMPurify from "dompurify";

export const re_only_numbers = /^[0-9\b]+$/;

export const withHttps = (url) => {
  if (!url) return "";
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

const monthKeys = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const monthLabel = (d, tr) => {
  const monthKey = monthKeys[d.getMonth()];
  const monthName = tr[monthKey] || monthKey;
  return `${monthName} ${d.getFullYear()}`;
}

export const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
export const endOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
export const addMonths = (d, delta) => new Date(d.getFullYear(), d.getMonth() + delta, 1);


export const SAFE_MODULES = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"]
  ]
};

export const SAFE_FORMATS = [
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet"
];

export const HtmlDiv = ({content}) => {
    const safe = DOMPurify.sanitize(content)
    return <div dangerouslySetInnerHTML={{ __html: safe }} />
}
